import React, {PropTypes} from 'react';
import { Icon } from '../../components';

export default class SubTitle extends React.Component {
  render() {
    return (<h4 className="modal-subtitle text-center">{this.props.children}</h4>)
  }
}
